module.exports = __webpack_public_path__ + "static/media/car-show-painting--resized.3fad46ae.jpg";